import api from './api';

/**
 * Chat service to handle API requests for chat operations
 */
export const chatService = {
  /**
   * Get message history for a campaign
   * 
   * @param {string} campaignId - Campaign ID
   * @returns {Promise<Array>} - Array of messages
   */
  getMessageHistory: async (campaignId) => {
    try {
      const response = await api.get(`/api/chat/sessions/${campaignId}/messages`);
      return response.data.messages || [];
    } catch (error) {
      console.error(`Error fetching message history for campaign ${campaignId}:`, error);
      throw error;
    }
  },

  /**
   * Get the SSE stream URL for chat
   * 
   * @returns {string} - SSE endpoint URL
   */
  getStreamUrl: () => {
    const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:8000';
    return `${apiBase}/api/chat/stream`;
  },

  /**
   * Edit a message and continue the conversation
   * 
   * @param {string} campaignId - Campaign ID
   * @param {number} messageIndex - Index of the message to edit
   * @param {string} newContent - New message content
   * @param {string} versionId - Version ID
   * @returns {Promise<Object>} - Response data
   */
  editAndContinue: async (campaignId, messageIndex, newContent, versionId) => {
    try {
      const response = await api.post(`/api/versioning/${campaignId}/edit-and-continue`, {
        message_index: messageIndex,
        new_content: newContent,
        version_id: versionId
      });
      return response.data;
    } catch (error) {
      console.error(`Error editing message in campaign ${campaignId}:`, error);
      throw error;
    }
  },

  /**
   * Revert campaign to a state before a specific message
   * 
   * @param {string} campaignId - Campaign ID
   * @param {string} versionId - Version ID to revert to
   * @returns {Promise<Object>} - Response data
   */
  revertToCampaignState: async (campaignId, versionId) => {
    try {
      const response = await api.post(`/api/versioning/${campaignId}/revert-from-message`, {
        version_id: versionId
      });
      return response.data;
    } catch (error) {
      console.error(`Error reverting campaign ${campaignId}:`, error);
      throw error;
    }
  }
};

export default chatService;

